/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import { useState } from 'react';
import { icons } from '~/assets';
import Button from '~/components/button';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/input';
import Loading from '~/components/loading';
import Tabs from '~/components/tab';
import useApi from '~/hooks/useApi';
import { useModal } from '~/hooks/useModal';
import { GetClientResponse } from '~/models/reprocessamento-fatura';
import Endpoints from '~/services/endpoints';
import { FormField, setFormState } from '~/utils/form';
import { creditCardMask } from '~/utils/masks';
import InvoiceView from '../components/invoiceView';
import { useInvoiceReprocess } from '../context';
import * as St from '../styles';

interface Form {
  cpf: FormField;
  numeroCartao: FormField;
  nome: FormField;
}
const formInitialState = {
  cpf: { name: 'cpf', value: '' },
  numeroCartao: { name: 'numeroCartao', value: '' },
  nome: { name: 'nome', value: '' },
};
const InvoiceReprocessIndex = () => {
  const [form, setForm] = useState<Form>(formInitialState);
  console.log('form', form);
  const {
    setClientData,
    setInvoiceData,
    clientData,
    clearData,
    invoiceData,
    setSelectedItems,
  } = useInvoiceReprocess();
  const GetClient = useApi<GetClientResponse>({
    url: Endpoints.reprocess.getClient,
    tryNewWay: true,
    fetchOnMount: false,
  });
  const onClearState = () => {
    GetClient.clear();
    setForm(formInitialState);
    clearData();
  };

  const { openModal, closeModal } = useModal();

  const onConsultClient = async () => {
    onClearState();
    const response = await GetClient.callApi({
      cpf: form.cpf.unmasked,
      numeroCartao: form.numeroCartao?.unmasked,
      nome: form.nome?.value,
    });
    if (response.status !== 200) {
      openModal({
        title: 'Houve um erro',
        message: response?.mensagem,
        icon: icons.exclamation,
        positiveAction: () => {
          closeModal();
          onClearState();
        },
      });
      return;
    }
    setSelectedItems(
      Object.fromEntries(response.data.faturas.map((e) => [e.idFatura, []])),
    );
    setClientData(response.data.cliente);
    setInvoiceData(response.data.faturas);
  };

  return (
    <>
      <Loading status={GetClient.loading} />

      <Container>
        <St.BoxCard>
          <ContainerFlex row space>
            <ContainerFlex padding={16}>
              <Input
                label="CPF"
                name={form.cpf.name}
                value={form.cpf.value}
                onChange={(e) => setFormState(e, form, setForm)}
                placeholder="000.000.000-00"
                maxLength={14}
                mask={MaskTypes.CPF}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Input
                label="Número do cartão"
                placeholder="0000.0000.0000.0000"
                maxLength={19}
                mask={MaskTypes.CREDIT_CARD}
                onChange={(e) => setFormState(e, form, setForm)}
                name={form.numeroCartao.name}
                value={
                  form.numeroCartao.value ||
                  creditCardMask(GetClient.data?.cliente?.numeroCartao)?.masked
                }
              />
            </ContainerFlex>

            {clientData?.cpf ? (
              <>
                <ContainerFlex padding={16}>
                  <Input
                    label="Nome"
                    onChange={() => {}}
                    name={'clientName'}
                    value={clientData.nome}
                  />
                </ContainerFlex>
                <ContainerFlex padding={16}>
                  <Input
                    label="Status do cartão "
                    onChange={() => {}}
                    name={'clientCardStatus'}
                    value={clientData.statusCartao}
                  />
                </ContainerFlex>
                <ContainerFlex padding={16}>
                  <Button fitContent onClick={onClearState}>
                    <span>Limpar</span>
                  </Button>
                </ContainerFlex>
              </>
            ) : (
              <ContainerFlex padding={16}>
                <Button
                  fitContent
                  onClick={onConsultClient}
                  loading={GetClient.loading}
                  disabled={
                    (form.cpf?.unmasked?.length !== 11 &&
                      form.numeroCartao?.unmasked?.length !== 16) ||
                    GetClient.loading
                  }
                >
                  <span>Consultar</span>
                </Button>
              </ContainerFlex>
            )}
          </ContainerFlex>
        </St.BoxCard>
        <ContainerFlex row horizontal gap="16">
          {invoiceData?.length > 0 ? (
            <Tabs initialTab={invoiceData.length - 1}>
              {invoiceData?.map((f) => {
                return (
                  <Tabs.Tab
                    label={`Fatura ${moment(
                      f.dataVencimento,
                      'YYYY-MM-DD',
                    ).format('DD/MM/YYYY')}`}
                    disabled={false}
                  >
                    <InvoiceView action data={f} />
                  </Tabs.Tab>
                );
              })}
            </Tabs>
          ) : null}
        </ContainerFlex>
      </Container>
    </>
  );
};

export default InvoiceReprocessIndex;
